/* eslint-disable no-undef */

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-23 16:19:03
 * @LastEditTime: 2022-01-26 22:16:05
 * @LastEditors: wangshengqiang
 * @Description: fda
 */
import Clipboard from 'clipboard';
import { getState } from '@/store';
import { goNext } from '@/utils/navigation';
import Modal from '@/components/Modal';
import { getModal, getPageConfigByPageId } from '@/utils/utils';
import renderModal from '@/components/Modal/Modal.js';
import EvenetHandle from './handle'; // 跳转外部页面

EvenetHandle.addType('link', events => {
  const {
    link
  } = events;
  window.location.href = link;
}); // 跳转列表页面

const page = events => {
  const {
    page: _page
  } = events;
  const [pageId, moduleId, tabIndex] = _page;
  const currentPage = Number(getState('currentPage'));
  const curr = getPageConfigByPageId(pageId) || {};
  const {
    pageOrder
  } = curr;

  if (pageOrder === currentPage) {
    const element = document.getElementById(moduleId);

    if (!element) {
      return;
    }

    if (getState('supervision')) {
      getState('supervision').show();
      getState('supervision').setTab(Number(tabIndex));
      return;
    }

    const tab = document.getElementsByClassName('c-AnchorTabsComponents-tabs')[0];

    if (tab) {
      const a = element.getBoundingClientRect().top;
      const tabT = tab.getBoundingClientRect().top;
      const b = document.documentElement.getBoundingClientRect().top;

      if (a > tabT) {
        document.documentElement.scrollTop = a - b - 50;
        document.body.scrollTop = a - b - 50;
      } else {
        document.documentElement.scrollTop = a - b;
        document.body.scrollTop = a - b;
      }
    } else {
      const a = element.getBoundingClientRect().top;
      const b = document.documentElement.getBoundingClientRect().top;
      document.documentElement.scrollTop = a - b - 50;
      document.body.scrollTop = a - b - 50;
    }
  } else {
    goNext(pageOrder);
  }
}; // 弹窗


const modal = events => {
  const {
    modal: modalId
  } = events;
  const curr = getModal(modalId) || {};

  const getClick = (_events, more = []) => {
    const {
      index = 0
    } = _events; // console.log('点击了按钮', events, more);

    if (index === 1 && (component === 'policyHolderInfoModule' || component === 'healthInfoModule')) {
      return () => {
        getNextStep(modal);
      };
    }

    more = toArray(more) || [];
    return getLocalClick(_events, more.concat(middlewares));
  };

  renderModal(curr, getClick);
}; // 内置操作


const behavior = events => {
  const {
    behavior: _behavior
  } = events;

  if (_behavior === 'copyAndOpenWechat') {
    const dom = document.createElement('div');
    dom.classList.add('behavior-copy-text');
    dom.setAttribute('data-clipboard-text', copyText);
    document.body.appendChild(dom); // eslint-disable-next-line no-new

    new Clipboard('.behavior-copy-text');
    dom.click();
    setTimeout(() => {
      window.location.href = 'weixin://';
    }, 0);
  } else if (_behavior === 'cancel') {
    Modal.hide();
  } else if (_behavior === 'close') {
    Modal.hide();
  }
};

EvenetHandle.addType('page', page);
EvenetHandle.addType('modal', modal);
EvenetHandle.addType('behavior', behavior);
export default EvenetHandle;